"use client";
import { Icon as _Icon } from "@iconify/react";
import { Box, BoxProps } from "@mui/material";

interface InconifyProp extends BoxProps {
  icon: string;
}

export const Iconify = ({ icon, sx, ...other }: InconifyProp) => {
  return <Box component={Icon} icon={icon} sx={{ ...sx }} {...other} />;
};

export const Icon = _Icon;
